<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Insurance Item Categories</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Insurance Item Categories
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form novalidate @submit.prevent="saveCategory">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Name</label>
                                        <input type="text" v-model="insuranceItemCategory.name" class="form-control"
                                               placeholder="Name"
                                               required>
                                        <div v-if="insuranceItemCategory.errors.name" class="text-danger text-small">
                                            {{ insuranceItemCategory.errors.name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Status</label>
                                        <select type="text" v-model="insuranceItemCategory.is_active" class="form-control" required>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                        <div v-if="insuranceItemCategory.errors.is_active" class="text-danger text-small">
                                            {{ insuranceItemCategory.errors.is_active }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <input type="text" v-model="insuranceItemCategory.description" class="form-control"
                                               placeholder="Description"
                                               required>
                                        <div v-if="insuranceItemCategory.errors.description" class="text-danger text-small">
                                            {{ insuranceItemCategory.errors.description }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Sort Order</label>
                                        <input type="text" v-model="insuranceItemCategory.sort_order" class="form-control"
                                               placeholder="Sort Order"
                                               required>
                                        <div v-if="insuranceItemCategory.errors.sort_order" class="text-danger text-small">
                                            {{ insuranceItemCategory.errors.sort_order }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import vueFilePond from "vue-filepond"
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

export default {
    metaInfo: {title: 'Create Insurance Item Category'},
    name: 'InsuranceItemCategory',
    props: ['isEditing', 'insuranceItemCategoryData'],
    layout: Layout,
    data() {
        return {
            insuranceItemCategory: this.$inertia.form({
                name: null,
                description: null,
                is_active: 1,
                sort_order: null,
            }),
            saving: false,
        }
    },
    methods: {
        async saveCategory() {
            this.saving = true;

            if (this.isEditing) {
                this.insuranceItemCategory.put(
                    route('admin.insurance-item-categories.update', this.insuranceItemCategoryData.id),
                    {...this.insuranceItemCategory},
                    {
                        forceFormData: true,
                        preserveScroll: true,
                        onSuccess: () => this.saving = false,
                        onError: () => {
                            this.saving = false;
                        }
                    }
                );
            } else {
                this.insuranceItemCategory.post(route('admin.insurance-item-categories.store'), this.insuranceItemCategory, {
                    forceFormData: true,
                    preserveScroll: true,
                    onSuccess: () => this.saving = false,
                    onError: () => {
                        this.saving = false;
                    }
                });
            }

            this.saving = false;
        }
    },
    mounted() {
        if (this.isEditing) {
            this.insuranceItemCategory.name = this.insuranceItemCategoryData.name
            this.insuranceItemCategory.description = this.insuranceItemCategoryData.description
            this.insuranceItemCategory.is_active = this.insuranceItemCategoryData.is_active ? 1 : 0
            this.insuranceItemCategory.sort_order = this.insuranceItemCategoryData.sort_order
        }
    },
}
</script>
